export default __webpack_public_path__ + "static/caseStudy2-fr-455911d45f267681f11f1ad2e70d3b9c.webp";